import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useStatsigClient } from '@statsig/react-bindings';

import type { SurveyListItem } from '@api/surveys/types';
import { GATES } from '@constants';
import { canPauseSurvey } from '@helpers/surveys';
import { ColumnsIcon, IconCTA, OverlayTriggerTooltip } from '@utilities';

import PauseModal from './components/PauseModal';

interface PauseProps {
  isHoverAction?: boolean;
  onSubmit: ({ refreshItems }: { refreshItems: boolean }) => void;
  selectedRows: Array<SurveyListItem>;
}

const Pause = ({ isHoverAction, onSubmit, selectedRows = [] }: PauseProps) => {
  const { permissions = {} } = useSelector((state: any) => state?.user?.data);
  const [isActive, setIsActive] = useState(false);

  const { client } = useStatsigClient();
  const useCalypsoProvider = client.checkGate(GATES.USE_CALYPSO_AS_SURVEY_PROVIDER);

  const handleSubmit = () => {
    setIsActive(false);
    onSubmit({ refreshItems: true });
  };

  if (selectedRows.length !== 1) return null;

  const isVisible = canPauseSurvey({ permissions, survey: selectedRows[0], useCalypsoProvider });
  if (!isVisible) return null;

  return (
    <>
      <OverlayTriggerTooltip content={isHoverAction ? 'Pause' : ''}>
        <IconCTA
          aria-label="Pause"
          data-testid="pause-cta"
          icon={<ColumnsIcon />}
          onClick={() => setIsActive(true)}
          text={isHoverAction ? '' : 'Pause'}
        />
      </OverlayTriggerTooltip>
      {isActive && (
        <PauseModal
          id={selectedRows[0].id}
          onClose={() => setIsActive(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default Pause;
